export const humFlags = { quiet: false };
const CYCLE = 45;
const SINK = 40;
export const runSinkingHum = (ctx, voices) => {
  let timer;
  const cycle = () => {
    const t0 = ctx.currentTime + 0.05;
    voices.forEach(({ o, f }) => {
      o.frequency.cancelScheduledValues(t0);
      o.frequency.setValueAtTime(f, t0);
      o.frequency.exponentialRampToValueAtTime(f * 0.5, t0 + SINK);
      o.frequency.setValueAtTime(f * 0.5, t0 + SINK + 0.4);
      o.frequency.exponentialRampToValueAtTime(f, t0 + SINK + 1.2);
    });
    window.__humCycleStart = performance.now();
    timer = setTimeout(cycle, (t0 + CYCLE - ctx.currentTime) * 1000);
  };
  const start = () => {
    if (ctx.state === "running") cycle();
    else timer = setTimeout(start, 500);
  };
  start();
  return () => clearTimeout(timer);
};
